export enum CALL_ORDER_TYPE_NUMBERS {
  AUDIO_CALL = 4,
}

export enum CALL_ORDER_STATUS_NUMBERS {
  CREATED = 1,
  ACCEPTED = 2,
  REJECTED = 3,
  COMPLETED = 4,
  CANCELED = 8,
}
